import SectionNavigator from './SectionNavigator';

export default SectionNavigator;
